import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { clientApiService } from '@/services/api/client.service';
import type { Client } from '@/types/clients';

export interface ClientsResponse {
  clients: Client[];
  total: number;
}

export const useClients = (params?: {
  status?: 'active' | 'inactive' | 'maintenance';
}) => {
  const { isAuthenticated, user } = useAuth();

  return useQuery<ClientsResponse>({
    queryKey: ['clients', params],
    queryFn: () => clientApiService.getAllClients(params),
    enabled: isAuthenticated && (user?.role === 'admin' || user?.role === 'developer'),
    staleTime: 60 * 1000, // 1 minute (matches backend cache)
    retry: 2,
    refetchOnWindowFocus: false
  });
};
